import React, {Component} from 'react';
import ReportGeneralTable from '../report/ReportGeneralTable'
import ReportStore from '../../stores/ReportStore'
import FontAwesome from 'react-fontawesome';
import { Popover, OverlayTrigger, Button } from 'react-bootstrap';
import StockNewMixColorDoc from './StockNewMixColorDoc';
import PullStock from 'component/element/PullStock'
import StockStore from '../../stores/StockStore';
import {connect} from 'react-redux'
var NotificationSystem = require('react-notification-system')
class StockMixColorReport extends Component {

  
  constructor(...args){
    super(...args)
    this.state = {showTable:true,mpNo:'',doc:'',showPull:false}
    this.qoTable = null
  }

  // renameDoc(newPoNo){
  //   this.refs.soDoc.renameDoc(newPoNo)
  // }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.show && newProps.show!==this.props.show){
      //this.loadData()
    }
  }

  showTable(){
    this.setState({showTable:true})
    if(this.qoTable!==null)
      this.qoTable.refreshTable()   
    if(this.props.onTableShow!==undefined){
      this.props.onTableShow()
    }
  }

  onRowSelect(item){
    this.setState({showTable:false,mpNo:item.doc_no,doc:item})
  }

  onDocNew(){
    
  }

  onDocClose(){
    this.showTable() 
  }

  loadData(year,month,day,searchBy,query,activePage,itemPerPage,callback){
    ReportStore.loadMixColorList(year,month,day,searchBy,query,activePage*itemPerPage,itemPerPage,callback)
  }

  loadDataRange(start,end,searchBy,query,activePage,itemPerPage,callback) {
    ReportStore.loadMixColorListRange(start,end,searchBy,query,activePage*itemPerPage,itemPerPage,callback)
  }

  // renderStatus(status,row){
  //   status = status*1
  //   let result  = (<span></span>)
  //   if(status===1){
  //     result =  (<span className='label label-success'>ชำระเงินแล้ว</span>)
  //   }else    if(status===2){
  //     result =  (<span className='label label-primary'>ขายเครดิต</span>)
  //   }else{
  //     result = (<span></span>)
  //   }
  //   if(row.recordid!==undefined && row.recordid*1>0){
  //     result = (<div>{result} {this.renderStockStatus(row.recordid)}</div>)
  //   }
  //   return result
  // }

  renderStatus(status,row){
    let result = (<span></span>)
    let {messages} = this.props
    if (row.work_status==0) {
      result = (<span className="label label-default" data-value="0">{messages['Start']}</span>)
    }else if (row.work_status==1) {
      result = (<span className="label label-warning" data-value="1">{messages['Under Repair']}</span>)
    } else if (row.work_status==2) {
      result = (<span className="label label-primary" data-value="2">{messages['Wait For Car']}</span>)
    } else if (row.work_status==3) {
      result = (<span className="label label-success" data-value="3">{messages['Work Done']}</span>)
    } else{
      result = (<span></span>)
    }

    return result
  }

  // renderStockStatus(status){ 
  //   status = status*1
  //   if(status>0){
  //     return (<span className='label label-default'>ตัดสต๊อกแล้ว</span>)
  //   }else{
  //     return (<span></span>)
  //   }

  // }

  onIconClick(workNo,e) {
    //alert("Click!")
    if (process.env.NODE_ENV === "development") {
      alert('show_work_doc:'+workNo)
    }else{
      window.show_work_doc(workNo)
    }
  }

  onRenderColumn(data,col,row){ 
      let {messages} = this.props
      if(col===9){ 
        return this.renderStatus(data,row)
      } else if (col===2) {
        if (data!="") {
          let title = messages['Work No']+" "+data
          let popoverHoverFocus = (
            <Popover id="popover-trigger-hover-focus" title={title}>
              <strong>{messages['Click Icon To View Worksheet']}</strong>
            </Popover>
          )

          return (
            <span>
              {data} <OverlayTrigger trigger={['hover', 'focus']} placement="right" overlay={popoverHoverFocus}><FontAwesome onClick={this.onIconClick.bind(this,data)} className="text-blue" name='file-text-o'/></OverlayTrigger>
            </span>
          )
        }  
      } else{ 
        return (<span>{data}</span>)
      }
  }

  onPullDataClick(cat_id) {
    let {messages} = this.props
    StockStore.loadSyncStockMixedcolor('color',(cat_id===''?'all':cat_id),(result)=>{
      if (result.status==='OK') {
        this.qoTable.refreshTable()
        this._notificationSystem.addNotification({
          title: messages['Notice'],
          message: messages['Sync Stock Data Amount']+' '+result.data.length+' '+messages['List'],
          level: 'info',
          position:'tc'
        });
      }
    })
  }

  renderToolBtn() {
    return(
      <Button bsStyle='danger' onClick={()=>{this.setState({showPull:true})}}><FontAwesome name='download'/>&nbsp;{this.props.messages['Pull Stock Data']}</Button>
    )
  }

  render(){
    let {doc,showTable} = this.state
    let {messages} = this.props
    const headerTitles = [
      {title:messages['Barcode'],width:'150px'},  
      {title:messages['Item Name'],width:'200px'},          
      {title:messages['Balance'],width:'150px'},
      {title:messages['Unit'],width:'150px'},
      {title:messages['Cost'],width:'150px'},
      {title:messages['Shelf'],width:'150px'},  
      {title:messages['First Picking up'],width:'150px'},
      {title:messages['Color Type'],width:'150px'},  
      {title:messages['Color Code'],width:'150px'},  
      {title:messages['Number Times Used'],width:'150px'},                      
    ]
    const searchOptions = [
      {
        label: messages['Barcode'],
        value: 'barcode'
      },      
      {
        label: messages['Work No'],
        value: 'work_no'
      }, 
      {
        label: messages['Car Registration'],
        value: 'car_registration_no'
      },
      {
        label: messages['Requester'],
        value: 'request_by'
      }     
    ]
    return (
      <div>
        <div style={{display:showTable?'block':'none'}}>
          <ReportGeneralTable 
          onRef={(ref)=>{this.qoTable = ref}}
          title={messages['Picking Color Mixed']} 
          txtTable={false}
          show={this.props.show}
          loadOnShow={true}
          showNewButton={false}
          showPrintButton={false}
          renderToolBtn={this.renderToolBtn.bind(this)}
          headerTitles={headerTitles}
          bodyColumn={['barcode','stock_description','quantity','unit','cost_per_unit','location','car_registration_no','color_type','colorcode','export_count']}
          excludeColumn={['status_html','doc_no','response_by','description','barcode']}
          excludeClickColumn={['work_no']}
          searchOptions={searchOptions}          
          searchBy={'barcode'}
          loadData={this.loadData.bind(this)}
          loadDataRange={this.loadDataRange.bind(this)}
          onRenderColumn={this.onRenderColumn.bind(this)}
          onRowSelect={this.onRowSelect.bind(this)} 
          docType={'quotation'}
          autoRowSelect={['barcode']}
          />
        </div>
        <div >
          <StockNewMixColorDoc 
            show={!showTable}
            doc={doc} 
            onClose={this.onDocClose.bind(this)}
          />
          <PullStock
            show={this.state.showPull}
            onHide={()=>{this.setState({showPull:false})}}
            stockType={'color'}
            onDataChange={this.onPullDataClick.bind(this)}
          />
          <NotificationSystem ref="notificationSystem" />
        </div>
      </div>
    )
  }
}

StockMixColorReport.defaultProps = {
  show : false
}
export default connect(
  (state) => ({messages: state.message.view.stock.StockMixColorReport}),null,null,{withRef:true},
)(StockMixColorReport);





// WEBPACK FOOTER //
// ./src/view/stock/StockMixColorReport.js